var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dropdown',{attrs:{"options":_vm.filteredProducts,"placeholder":"-- selecteer een product --","max-item":30},on:{"filter":_vm.onFilter,"selected":_vm.onSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }